import React from 'react';
import { faWandSparkles } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@tryhackme/thm-ui-components';
import { ModalLayout } from '../../../modal';
import { StyledConfirmModalText, StyledLoadingSpinner } from './random-avatar-confirm-modal.styles';
import { RandomAvatarConfirmModalProps } from './random-avatar-confirm-modal.types';
export const GenerateRandomAvatarConfirmModal = ({
  handleActionButton,
  isGeneratingRandomAvatar
}: RandomAvatarConfirmModalProps) => {
  const [open, setOpenChange] = React.useState<boolean>(false);
  const handleModalAction = async () => {
    await handleActionButton();
    setOpenChange(false);
  };
  return <ModalLayout open={open} openChange={setOpenChange} showTriggerElement triggerText="Generate random avatar" modalTitleText="Generate random avatar" closeButtonText="Cancel" triggerButtonColor="add" triggerButtonIcon={faWandSparkles} showWarnBox={false} actionElement={
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  <Button data-testid="action-button" onClick={handleModalAction} disabled={isGeneratingRandomAvatar}>
          {isGeneratingRandomAvatar && <StyledLoadingSpinner color="#151C2B" />}
          {isGeneratingRandomAvatar ? 'Generating avatar...' : 'Generate random avatar'}
        </Button>} data-sentry-element="ModalLayout" data-sentry-component="GenerateRandomAvatarConfirmModal" data-sentry-source-file="random-avatar-confirm-modal.tsx">
      <StyledConfirmModalText data-sentry-element="StyledConfirmModalText" data-sentry-source-file="random-avatar-confirm-modal.tsx">
        Are you sure you want to generate an icon from our random icons collection?
      </StyledConfirmModalText>
    </ModalLayout>;
};